import { createApi } from '@reduxjs/toolkit/query/react';

import { createBaseQuery } from '../baseQuery/createBaseQuery';

// Example of creating multiple base APIs
export const baseApiV1 = createApi({
  reducerPath: 'baseApiV1',
  baseQuery: createBaseQuery({ version: 'v1' }),
  endpoints: () => ({}), // inject endpoints at the feature level
});

export const baseApi = baseApiV1;
